/**
 * UserGroupEmptyState — contextual empty state for the user groups table.
 * @param {{ type: 'no-data' | 'no-results', onAddGroup?: () => void, onClearFilters?: () => void }} props
 */
const UserGroupEmptyState = ({ type, onAddGroup, onClearFilters }) => {
  if (type === 'no-data') {
    return (
      <div className="up-empty">
        <div className="up-empty__icon-wrap">
          <i className="fe fe-layers up-empty__icon" aria-hidden="true" style={{ fontSize: '1.5rem' }} />
        </div>
        <h3 className="up-empty__title">No user groups yet</h3>
        <p className="up-empty__text">
          Get started by creating your first user group. Groups help organize users for notifications and management.
        </p>
        {onAddGroup ? (
          <button
            type="button"
            onClick={onAddGroup}
            className="up-btn up-btn--primary"
          >
            <i className="fe fe-plus" aria-hidden="true" />
            New Group
          </button>
        ) : null}
      </div>
    );
  }

  return (
    <div className="up-empty">
      <div className="up-empty__icon-wrap">
        <i className="fe fe-search up-empty__icon" aria-hidden="true" style={{ fontSize: '1.5rem' }} />
      </div>
      <h3 className="up-empty__title">No results found</h3>
      <p className="up-empty__text">
        No user groups match your current search or filter criteria. Try adjusting your search terms or clearing filters.
      </p>
      {onClearFilters ? (
        <button
          type="button"
          onClick={onClearFilters}
          className="up-btn up-btn--outline"
        >
          <i className="fe fe-x" aria-hidden="true" />
          Clear All Filters
        </button>
      ) : null}
    </div>
  );
};

export default UserGroupEmptyState;
